import Service from "../../../service/api-competency.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {

        item:[],
        status:[],
        plans:[],
        isReload: false,

        members:[]
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },

        status(state, obj) {
            state.status = obj;
        },

        plans(state, obj) {
            state.plans = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        },

        members(state, data) {
            state.members = data;
        }
    },

    actions: {
        config({commit}, data) {
            Service.Report_Assessment('report_assessment', data, {})
                .then((response) => {
                    store.commit("report/item", response.data.data)
                    store.commit("report/isReload",true)

                }).catch((err) => {
            });
        },
        members({commit}, data) {
            Service.idpReport('explore', data, {})
                .then((response) => {
                    console.log(12,response.data.data)
                    store.commit("report/members", response.data.data)
                }).catch((err) => {
            });
        },


        status({commit}, data) {
            Service.idpReport('status', data, {})
                .then((response) => {
                    store.commit("report/status", response.data.data[0].item)
                    store.commit("report/isReload",true)

                }).catch((err) => {
            });
        },




        plans({commit}, data) {
            Service.idpReport('plans', data, {})
                .then((response) => {
                    store.commit("report/plans", response.data.data)
                    store.commit("report/isReload",true)

                }).catch((err) => {
            });
        },

    },

    getters: {
        item(state, obj) {
            return state.item;
        },
        status(state, obj) {
            return state.status;
        },
        plans(state, obj) {
            return state.plans;
        },
        isReload(state, obj) {
            return state.isReload;
        },
        members(state, obj) {
            return state.members;
        }
    },
};

export default ServerModule;
